module.exports = __webpack_public_path__ + "img/laboratorio_16-9_2880.35b400d9.webp";